import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { DoctorLink } from '../../relation-request.interface';
import { doctorLinkReceivedRowData } from '../doctor-link-table-factory';

export class DoctorLinkReceivedTable {
  public buildTableData(items: DoctorLink[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.SPECIALTIES, ColumnTypes.DATE, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'manage', key: 'manage' };
  }

  private getTableBody(items: DoctorLink[]): GridTableBody[] {
    return items.map(doctorLinkReceivedRowData);
  }
}
